/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import images from '../../../images';
import { __ } from '../../../locales';

/**
 * This component shows the levels which passed or have not passed yet on the top of games' page
 *
 */

const Levels = ({ levels, currentLevelKey, modalVisible }) => {
  const numOfLevels = Object.keys(levels).length;

  const currentLevelValue = (currentLevelKey !== undefined) ? Number(currentLevelKey.split('_')[1].split('_')[0] - 1) : 0;
  const MainContainer = styled.div`
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    margin-top: 10%;
  `;

  const Container = styled.div`
    padding: 10px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `;

  const LevelItem = styled.div`
    background-color: #565252;
    height: ${window.innerWidth / (numOfLevels * 4)}px;
    width: ${window.innerWidth / (numOfLevels * 4)}px;
    border-radius: 50%;
    color: white;
    background-size: contain;
    background-position: center;

    &.active {
      background-color: #2685d0;
      color: white;
    }

    &.finished {
      background-image: url(${images.level_completed});
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
    }
  `;

  const Level = styled.span`
    margin-top: ${window.innerWidth / (numOfLevels * 20)}px;
    display: block;
    text-align: center;
    font-size: ${window.innerWidth / (numOfLevels * 7)}px;
  `;

  const Line = styled.div`
    margin-top: ${window.innerWidth / (numOfLevels * 9)}px;;
    width: ${window.innerWidth / (numOfLevels * 1.4)}px;
    height: ${window.innerHeight / 200}px;
    border-radius: 15%;
    background-color: #565252;
    &.passedLevels {
      background-color: #2685d0;
    }
    &.upCommingLevel {
      background-color: rgba(38, 133, 208, 0.5);
    }
`;
  const LevelsText = styled.p`
    font-size: ${window.innerWidth / (numOfLevels * 8)}px;
    color: #000;
    margin-left: 3%;
`;

  return (
    <MainContainer>
      <LevelsText>{__('app.level_upper_case')}</LevelsText>
      <Container>
        {
          Object.keys(levels).map((level, i) => (
            <>
              <LevelItem
                className={(currentLevelValue === i && !modalVisible && 'active') || ((currentLevelValue > i || (currentLevelValue === i && modalVisible)) && 'finished')}
              >
                <Level>{i + 1}</Level>
              </LevelItem>
              {(i < numOfLevels - 1) && <Line className={(currentLevelValue > i && 'passedLevels') || ((currentLevelValue === i && modalVisible) && 'upCommingLevel')} />}
            </>
          ))
        }
      </Container>
    </MainContainer>
  );
};

export default Levels;
